import { ethers } from 'ethers';
/**
 * Detect if the wallet injecting the ethereum object is Flask.
 *
 * @returns True if the MetaMask version is Flask, false otherwise.
 */
export const isFlask = async () => {
  const provider = window.ethereum;
  try {
    const clientVersion = await provider?.request({
      method: 'web3_clientVersion',
    });

    const isFlaskDetected = (clientVersion as string[])?.includes('flask');

    return Boolean(provider && isFlaskDetected);
  } catch {
    return false;
  }
};

export const getSigner = () => {
  const provider = new ethers.BrowserProvider(window.ethereum);

  // Request account access if needed
  window.ethereum.enable();

  // Getting the signer from provider
  return provider.getSigner();
};
